import { render, staticRenderFns } from "./AdminStaff.vue?vue&type=template&id=43ad6f68&scoped=true"
import script from "./AdminStaff.vue?vue&type=script&lang=js"
export * from "./AdminStaff.vue?vue&type=script&lang=js"
import style0 from "./AdminStaff.vue?vue&type=style&index=0&id=43ad6f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ad6f68",
  null
  
)

export default component.exports